import { useCallback } from 'react';

import { ModalBody, ModalHeader } from 'apps/shared/scripts/components';
import { useFormCallback } from 'apps/shared/scripts/hooks';

import LoginContainer from './LoginContainer';

interface Props {
  onBack: () => void;
  onCancel: () => void;
  onComplete: () => void;
  onForgot: () => void;
  onSignup: () => void;
}

const LoginModalContainer = ({
  onBack,
  onCancel,
  onComplete,
  onForgot,
  onSignup,
}: Props) => {
  const { onSuccess: onSuccessForm } = useFormCallback();

  const onSuccess = useCallback(() => {
    onSuccessForm({ message: 'Logged in successfully' }); // todo(): onSuccess('msg', cb)
    onComplete();
  }, [onComplete, onSuccessForm]);

  return (
    <>
      <ModalHeader onBack={onBack} onDismiss={onCancel} title={'Log in'} />
      <ModalBody>
        <LoginContainer
          onSuccess={onSuccess}
          onForgot={onForgot}
          onSignup={onSignup}
          modal
        />
      </ModalBody>
    </>
  );
};

LoginModalContainer.displayName = 'LoginModalContainer';

export default LoginModalContainer;
